import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  TitleProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ShowButton,
  TextField,
  SelectInput,
} from 'react-admin'
import { MediaContentTypes } from '../../../../core/enum/MediaContentTypes'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import FilteredReferenceInput from '../../../common/FilteredReferenceInput'
import { ResourceName } from '../../../../core/ResourceName'
import { EngineMediaFileDto } from '../../../../core/dto/engine-media/engine-media-file.dto'

const validateEngineMediaFileEdit = (values: EngineMediaFileDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.engineMediaActionId) {
    errors.engineMediaActionId = 'ra.validation.required'
  }
  if (!values.mediaContentType) {
    errors.mediaContentType = 'ra.validation.required'
  }
  if (!values.filePathId) {
    errors.filePathId = 'ra.validation.required'
  }
  return errors
}

interface EngineMediaFileTitleProps extends TitleProps {
  record?: EngineMediaFileDto
}

const EditTitle = (data: EngineMediaFileTitleProps) => {
  const { record: action } = data
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.engine-media-files.titles.edit')}: {action?.id}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaFileEdit = (props: EditProps) => {
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Edit {...props} hasShow={false} title={<EditTitle />}>
      <SimpleForm
        redirect="show"
        toolbar={<EditToolbar />}
        validate={validateEngineMediaFileEdit}
      >
        <TextField source="id" label="ID" />
        <TextInput source="description" />
        {hasAuthority(Authority.VIEW_ENGINE_MEDIA_ACTIONS) && (
          <FilteredReferenceInput
            source="engineMediaActionId"
            reference={ResourceName.ENGINE_MEDIA_ACTIONS}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            filterSource="name"
            selectWithPaginationInputProps={{
              optionText: 'name',
              showFilter: true,
            }}
          />
        )}
        {hasAuthority(Authority.VIEW_FILES) && (
          <FilteredReferenceInput
            source="filePathId"
            reference={ResourceName.FILES}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            filterSource="name"
            selectWithPaginationInputProps={{
              optionText: 'name',
              showFilter: true,
            }}
            filter={{
              fileExtension: '.jpg,.png,.jpeg,.avi',
            }}
          />
        )}
        <SelectInput
          source="mediaContentType"
          choices={Object.entries(MediaContentTypes).map(([value]) => ({
            id: value,
            name: `resources.enums.MediaContentTypes.${value}`,
          }))}
        />
      </SimpleForm>
    </Edit>
  )
}
